module.exports = __webpack_public_path__ + "static/media/main-bird-rest-dialog.62ffdfd9.png";